<template>
  <div>
    <div class="mt-2">
      <button type="button" class="btn btn-link" @click="showModal = true">
        <i class="fa fa-pencil-square"></i>
      </button>
    </div>
   <OrderItemActivityVariantModal
       :order-item="orderItem"
       :children="children"
       :update-item-url="updateItemUrl"
       :show-modal="showModal"
       :activities-url="activitiesUrl"
       @exit-modal="showModal = false"
       @modal-close="showModal = false"
     ></OrderItemActivityVariantModal>
  </div>
</template>

<script setup>
import { defineProps, ref } from 'vue';
import OrderItemActivityVariantModal from "@/components/orders/OrderItemActivityVariantModal.vue";

const props = defineProps({
  orderItem : {
    type: Object,
  },
  children : {
    type: Array,
    default: () => { return []}
  },
  updateItemUrl : {
    required: true,
    type: String,
  },
  activitiesUrl : {
    required: true,
    type: String,
  },
})

const showModal = ref(false);
</script>